import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class Globals {
  constructor(@Inject(PLATFORM_ID) platformId: string) {
    this.isBrowser = isPlatformBrowser(platformId);
  }
  isBrowser: boolean;
  TEMPLATE_TYPES = {
    SIDEBAR: 'sidebar',
    ARTICLE: 'article',
    TECHNICAL: 'technical',
    LISTING: 'listing',
    SERVICE_DISCOVERY: 'service_discovery',
    LANDING: 'landing',
    REDOC: 'redoc',
    PRODUCT: 'product',
    HOME: 'home',
    BUSINESS_TYPE: 'business-type',
    APIS_PAGE: 'solution-finder',
    HOMEPAGE: 'homepage',
    LEARNINGPAGE: 'learningpage',
    API_OVERVIEW: 'api-overview',
    PRODUCT_LANDING: 'product-landing',
    CATEGORY: 'category',
    DOC_PAGE: 'doc-page',
    PROD_DOC_PAGE: 'prod-doc-page',
    ARTICLE_PAGE: 'article',
    SDK_PAGE: 'sdk',
    PUBLIC: 'public',
    CONTACT_PAGE: 'contact-page',
    CONTACT_SALES: 'contact-sales',
    SEARCH_RESULT: 'searchresult'
  };
  DATE_FORMAT = 'D MMM YYYY';
  static emailValidationRegEx = '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[.a-zA-Z]{2,7}$';
  CONTACT_SALES_SEC_HEADER_TITLE = 'Need Help?';
  CONTACT_SALES_GENERIC_TITLE = 'Get in touch with Worldpay';
  CONTACT_SALES_GENERIC_SUBHEADING = 'Ready to partner with Us?';
  CONTACT_SALES_GENERIC_DETAILS = 'Connect with our team by completing the form below.';
  CONTACT_SALES_PRODUCT_TITLE = 'Need help with';
  CONTACT_SALES_PRODUCT_SUBHEADING = 'Get in touch!';
  CONTACT_SALES_PRODUCT_DETAILS =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. ' +
    'Proin vitae mi pharetra, ultricies ligula et, facilisis dolor. ' +
    'Aenean feugiat erat ac arcu consectetur commodo vitae ac enim.';

  internalDomains: string[] = ['@worldpay.com', '@fisglobal.com'];
}
